module.exports = __webpack_public_path__ + "img/declaration-domain.11570b59.png";